import { Button, mobileStore, OrdersProps, themeStore, userStore } from "@root/common"
import { ArrowStyled, OrdersWindowStyled, OrdersWrap } from "./OrdersStyled"
import { FC, useMemo, useState } from "react"
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { observer } from "mobx-react-lite";
import { ChooseModeForm } from "./ChooseModeForm";
import { useAsync } from "react-async-hook";
import { getBingxSpotOrderCoins, getOrders, OrdersMode } from "../../api/orders.api";
import { OrdersForm, ToastMessage } from "./OrdersForm";
import { toast } from "react-toastify";

export const Orders: FC<OrdersProps & {width: number, top: number}> = observer((props) => {
  const {type, long, short, coin, width, top} = props
  const [isOpen, setIsOpen] = useState(false)

  const [mode, setMode] = useState<OrdersMode | undefined>()
  const {result: orders} = useAsync(async () => {
    try {
      return await getOrders()
    } catch (err: any) {
      console.log('enter catch')
      if (err?.error) {
        toast(() => <ToastMessage
          title="GET /api/orders"
          logs={{
            success_logs: [],
            errors: [{
              type: "Ошибка",
              message: (err as Error).message
            }]
          }}
        />)
      }
    }
  }, [])

  const {result: spotCoins} = useAsync(async () => {
    if (long === 'bingx' && type === 'spot') return await getBingxSpotOrderCoins()
    else return []
  }, [])


  const isVisible = useMemo(() => {
    if (!orders || !long || !short) {
      return false;
    }
    if (long === 'bingx' && type === 'spot') {
      if (!spotCoins?.length || !spotCoins?.includes(coin)) {
        return false
      } else if (spotCoins?.length && spotCoins?.includes(coin)) return true
    }


    switch (type) {
      case "futures": {
        return [long, short].every(fut => orders.futures.includes(fut))
      }
      case "spot": {
        return orders.spot.includes(long) && orders.futures.includes(short)
      }
      case "margin": {
        return orders.futures.includes(long) && orders.margin.includes(short)
      }
    }
  }, [orders, type, spotCoins])

  if (!isVisible || !mobileStore.isOrdersVisible()) {
    return (
      <></>
    )
  }

  return (
    <OrdersWrap style={{width: `${width}px`, top: `${top}px`}}>
      <Button
        onClick={e => setIsOpen(cur => !cur)}
        style={{
          position: 'relative',
          left: '6px',
          width: '100%',
          padding: '8px',
          textAlign: 'left'
        }}
      >
        <p>Ордера</p>
        <ArrowStyled>
          {isOpen ? <ArrowDropDownIcon fontSize="large"/> : <ArrowRightIcon fontSize="large"/>}
        </ArrowStyled>
      </Button>
      <OrdersWindowStyled
        style={{
          backgroundColor: themeStore.bgColor,
          color: themeStore.textColor,
          border: `1px solid ${themeStore.textColor}`,
          display: isOpen ? "flex" : "none"
        }}
      >
        {!mode && <ChooseModeForm onChange={mode => {setMode(mode)}}/>}
        <OrdersForm {...props} mode={mode} setMode={setMode}/>
      </OrdersWindowStyled>
    </OrdersWrap>

  )
})
